import { MenuType } from "src/common/types/menu";

export let M: MenuType[] = [];

export const MenuSet = (Menu: MenuType[]) => {
  M = Menu;
};
